<template>
  <v-col
    cols="auto"
    align-self="center"
  >
    <dialog-open-project
      icon="mdi-folder-open"
      :only-icon="true"
      :is-rounded="true"
      :is-from-creation-page="true"
      @open-project="openProject"
    />
    <dialog-project
      ref="saveProject"
      :title-dialog="$t('project.save')"
      :base-project-name="projectName"
      :base-project-duration="projectDuration"
      @select="saveFile"
    />
  </v-col>
</template>

<script>
// Components
import dialogProject from "@/components/Dialog/DialogProject";
import dialogOpenProject from "@/components/Dialog/DialogOpenProject";

export default {
  components: {
    dialogProject,
    dialogOpenProject,
  },
  props: {
    projectName: {
      type: String,
      default: "",
    },
    projectDuration: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    openSaveDialog() {
      this.$refs.saveProject.openDialog();
    },
    openProject(fileObj) {
      this.$emit("load-file", fileObj);
    },
    saveFile(fileObj) {
      this.$emit("saveFile", fileObj);
    },
  },
};
</script>

<style></style>
